import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateOrganizationConfigComponent } from "./create-organization-config/create-organization-config.component";
import { OrganizationService } from 'src/app/private/services/organization.services';

@Component({
  selector: 'app-orgnaization-config',
  imports: [SharedModule, CreateOrganizationConfigComponent],
  templateUrl: './orgnaization-config.component.html',
  styleUrl: './orgnaization-config.component.scss'
})
export class OrgnaizationConfigComponent {
  @Input() orgId: string = '';
  displayAddModal: boolean = false;

  organizationConfig: any = null;
  displayEditModal: boolean = false;


  rows = 50;
  totalRecords = 0;
  loading = false;
  orgDataToEdit: any = null;



  orgActionItem: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Organization Config',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.displayEditModal = true;
          }
        }
      ]
    }
  ]

  constructor(
    private orgService: OrganizationService,
  ) { }

  openAddModal() {
    this.displayAddModal = true;
  }

  ngOnInit() {
    this.getOrganizationConfig();
  }


  getOrganizationConfig() {
    const payload = {
      "organization_id": this.orgId
    }
    this.loading = true;
    this.orgService.getOrgConfigById(payload).subscribe({
      next: (res) => {
        this.loading = false;
          if(res){
            this.organizationConfig = [res];
          }else{
            this.organizationConfig = [];
          }
          
          this.totalRecords = this.organizationConfig.length;
          this.loading = false
      },
      error: (err) => {
        this.loading = false;
      }
    }
    )
  }


  setOrgData(orgData: any) {
    this.orgDataToEdit = orgData;
  }

}
